// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2qkh1","validationTips":"StatementDescriptor_validationTips__3dkW0"};